import { render } from "./FieldMapper.vue?vue&type=template&id=aefe11ba&scoped=true"
import script from "./FieldMapper.vue?vue&type=script&lang=js"
export * from "./FieldMapper.vue?vue&type=script&lang=js"

import "./FieldMapper.vue?vue&type=style&index=0&id=aefe11ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aefe11ba"]])

export default __exports__